import jwtDecode from "jwt-decode";
import {PostRequest} from "@configs/request";
import {handleLogin} from "@store/actions/auth";
import {handleCart} from "@store/actions/Cart";
import {handleWallet} from "@store/actions/Wallet";
import {urls} from "@api/urls";
import {store} from "@store";

const Ping = async () => {
    const token = localStorage.getItem("token");
    const response = await PostRequest(urls.web.ping, {token}, {Authorization: token});

    if (response?.ok) {
        const {token} = response.data;
        store.dispatch(handleLogin(token));
        store.dispatch(handleCart(jwtDecode(token)));
        store.dispatch(handleWallet(jwtDecode(token)));
    }
};

export default Ping;
